var lib_core = require("lib-core");
var ui_templates = require("ui-templates");

var AssetAdderView = function(model, stateMachine) {
    var self = this;

    this.model = model;
    this.stateMachine = stateMachine;

    this.model.selectVersionModalShown.onChange(this, function(value){
         if(value)
            self.showSelectVersionModal();
        else
            self.hideSelectVersionModal();
    },1);
};

module.exports = AssetAdderView;


AssetAdderView.prototype.showSelectVersionModal = function() {
    var self = this;
    var body;
    if(this.model.selectVersionModalShown().hasLastVersion) {
        body = "The asset you are trying to add has been modified since the latest version was created. \
                To include these modifications, create a new version now.";
    } else {
        body = "The asset you are trying to add does not have a version yet. \
                To use the asset, create a new version now.";
    }

    this.modal = new ui_templates.Modal({
        target: $("body"),
        fields: {
            'title': "Asset has no recent version",
            'body': body
        }
    });

    var button1 = this.modal.addButton("Create new version", "regular");
    button1.$el.on('Cioui:Modal:ModalButton:clicked', function(){
        var cEvent2 = new lib_core.GuiEvent(lib_core.GuiEvents.ASSET_ADD_NEW_VERSION);
        self.stateMachine.handle(cEvent2);
    });

    if(this.model.selectVersionModalShown().hasLastVersion) {
        var button2 = this.modal.addButton("Use latest version", "inverted");
        button2.$el.on('Cioui:Modal:ModalButton:clicked', function(){
            var cEvent2 = new lib_core.GuiEvent(lib_core.GuiEvents.ASSET_ADD_LATEST_VERSION);
            self.stateMachine.handle(cEvent2);
        });
    }

    var button3 = this.modal.addButton("Open in editor", "inverted");
    button3.$el.on('Cioui:Modal:ModalButton:clicked', function(){
        var cEvent2 = new lib_core.GuiEvent(lib_core.GuiEvents.ASSET_ADD_EDIT);
        self.stateMachine.handle(cEvent2);
    });

    this.modal.$el.on('Cioui:Modal:close:clicked', function(){
        var cEvent2 = new lib_core.GuiEvent(lib_core.GuiEvents.ASSET_ADD_CANCEL);
        self.stateMachine.handle(cEvent2);
    });
};

AssetAdderView.prototype.hideSelectVersionModal = function() {
    if(this.modal) this.modal.remove();
    this.modal = null;
};
